module.exports = __webpack_public_path__ + "static/img/h10.e52c68b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/multidaytours/tour3/h10.jpg
// module id = ONaA
// module chunks = 0